module.exports = __webpack_public_path__ + "img/2.4e630748.jpg";